import script from "./OpenCooperation.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenCooperation.vue?vue&type=script&lang=ts&setup=true"

import "./OpenCooperation.vue?vue&type=style&index=0&id=a991c9fe&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a991c9fe"]])

export default __exports__